import { BKJComboBox } from '@awais4123/fillify-design-library';
import { FC } from 'react';
import { shiftUnpaidBreakTimeDropdownOptions } from './ShiftUnpaidBreakTimeSelectInput.constants';
import { IShiftUnpaidBreakTimeSelectInputProps } from './ShiftUnpaidBreakTimeSelectInput.types';

export const ShiftUnpaidBreakTimeSelectInput: FC<IShiftUnpaidBreakTimeSelectInputProps> = ({
  disabled = false,
  name,
  placeholder,
  value,
  onChange,
  label,
  error,
}) => {
  return (
    <BKJComboBox
      leftIconProps={{ iconName: 'ShiftsUnpaidBreak' }}
      disabled={disabled}
      label={label}
      options={shiftUnpaidBreakTimeDropdownOptions}
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={onChange}
      action="OpenToggle"
      type="Single"
      error={error}
    />
  );
};
